import Vue from 'vue'
import Vuex from 'vuex';
import router from '../router';
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: {
      username: '',
      first_name: '',
      last_name: '',
      email: '',
      company: '',
      image: 'user2-160x160.jpg',
      erp_system_name: ''
    },
    env: getEnv(),
    loggedInStatus: false,
    roles: {
      co_accounting: false,
      co_dashboard: false,
      co_orders: false,
      co_orders_send: false,
      co_admin: false,
      co_products: false
    },
    salesChannels: [
      {id: 1, name: 'schuhe.de', img: 'schuhede-parent.svg'},
      {id: 2, name: 'eBay', img: 'schuhede-ebay.svg'},
      {id: 3, name: 'Zalando', img: 'schuhede-zalando.svg'},
      {id: 4, name: 'Amazon', img: 'schuhede-amazon.svg'},
      {id: 5, name: 'eBay', img: 'ebay.svg'},
      {id: 6, name: 'Zalando', img: 'zalando.svg'},
      {id: 7, name: 'Amazon', img: 'amazon.svg'},
      {id: 8, name: 'schuhe.de - Parent', img: 'schuhede-parent.svg'},
      {id: 9, name: 'Spartoo', img: 'spartoo.svg'},
      {id: 10, name: 'Spartoo', img: 'schuhede-spartoo.svg'},
      {id: 11, name: 'Mirapodo', img: 'mirapodo.svg'},
      {id: 12, name: 'Mirapodo', img: 'schuhede-mirapodo.svg'},
      {id: 13, name: 'Warentrade', img: 'warentrade.svg'},
      {id: 14, name: 'Warentrade - Amazon', img: 'warentrade.svg'},
      {id: 15, name: 'Warentrade - eBay', img: 'warentrade.svg'},
      {id: 16, name: 'Warentrade - Spartoo', img: 'warentrade.svg'},
      {id: 17, name: 'Tamaris', img: 'tamaris.svg'},
      {id: 18, name: 'Tamaris', img: 'schuhede-tamaris.svg'},
      {id: 39, name: 'Tamaris AT', img: 'tamaris.svg'},
      {id: 40, name: 'Tamaris AT', img: 'schuhede-tamaris.svg'},
      {id: 19, name: 'Check24', img: 'check24.svg'},
      {id: 20, name: 'Check24', img: 'schuhede-check24.svg'},
      {id: 27, name: 'Legero', img: 'legero.svg'},
      {id: 38, name: 'Goertz', img: 'goertz.svg'},
      {id: 41, name: 'Marco Tozzi', img: 'marco_tozzi.svg'},
      {id: 42, name: 'Marco Tozzi', img: 'schuhede-marco_tozzi.svg'},
      {id: 43, name: 'Sport2000', img: 'sport2000.svg'},
      {id: 44, name: 'Sport2000', img: 'schuhede-sport2000.svg'},
      {id: 45, name: 'Gabor', img: 'schuhede-gabor.svg'},
      {id: 46, name: 'Avendu', img: 'merchant_order_avendu.svg'},
      {id: 47, name: 'Caprice', img: 'caprice.svg'},
      {id: 48, name: 'Caprice', img: 'schuhede-caprice.svg'},
      {id: 49, name: 'schuhe.de Neu', img: 'selfservice_schuhede.svg'},
      {id: 50, name: 'schuhe.de Neu', img: 'schuhede-selfservice_schuhede.svg'},
      {id: 51, name: 'Limango.de', img: 'limango_de.svg'},
      {id: 52, name: 'Limango.de', img: 'schuhede-limango_de.svg'},
      {id: 53, name: 'Kaufland.de', img: 'kaufland_de.svg'},
      {id: 54, name: 'Kaufland.de', img: 'schuhede-kaufland_de.svg'},
      {id: 55, name: 'Atalanda', img: 'merchant_order_atalanda.svg'},
      {id: 56, name: 'Bagmondo', img: 'merchant_order_bagmondo.svg'},
      {id: 57, name: 'ATS.de', img: 'ats_de.svg'},
      {id: 58, name: 'ATS.de', img: 'schuhede-ats_de.svg'}
    ],
    filterChannels: [
      {id: 1, name: 'schuhe.de', img: 'schuhede-parent.svg', icon: 'fa-schuhe'},
      {id: 2, name: 'eBay', img: 'schuhede-ebay.svg', icon: 'fa-ebay'},
      {id: 3, name: 'Zalando', img: 'schuhede-zalando.svg', icon: 'fa-zalando'},
      {id: 4, name: 'Amazon', img: 'schuhede-amazon.svg', icon: 'fa-amazon'},
      {id: 10, name: 'Spartoo', img: 'schuhede-spartoo.svg', icon: 'fa-spartoo'},
      {id: 12, name: 'Mirapodo', img: 'schuhede-mirapodo.svg', icon: 'fa-mirapodo'},
      {id: 18, name: 'Tamaris', img: 'schuhede-tamaris.svg', icon: 'fa-tamaris'},
      {id: 40, name: 'Tamaris AT', img: 'schuhede-tamaris.svg', icon: 'fa-tamaris'},
      {id: 20, name: 'Check24', img: 'schuhede-check24.svg', icon: 'fa-check-24'},
      {id: 38, name: 'Goertz', img: 'schuhede-goertz.svg', icon: 'fa-goertz'},
      {id: 42, name: 'Marco Tozzi', img: 'schuhede-marco_tozzi.svg', icon: 'fa-marco_tozzi'},
      {id: 44, name: 'Sport2000', img: 'schuhede-sport2000.svg', icon: 'fa-sport2000'},
      {id: 45, name: 'Gabor', img: 'schuhede-gabor.svg', icon: 'fa-gabor'},
      {id: 46, name: 'Avendu', img: 'merchant_order_avendu.svg', icon: 'fa-merchant_order_avendu'},
      {id: 48, name: 'Caprice', img: 'schuhede-caprice.svg', icon: 'fa-caprice'},
      {id: 50, name: 'schuhe.de Neu', img: 'schuhede-selfservice_schuhede.svg', icon: 'fa-selfservice_schuhede'},
      {id: 52, name: 'Limango.de', img: 'schuhede-limango_de.svg', icon: 'fa-limango_de'},
      {id: 54, name: 'Kaufland.de', img: 'schuhede-kaufland_de.svg', icon: 'fa-kaufland'},
      {id: 55, name: 'Atalanda', img: 'merchant_order_atalanda.svg', icon: 'fa-merchant_order_atalanda'},
      {id: 56, name: 'Bagmondo', img: 'merchant_order_bagmondo.svg', icon: 'fa-merchant_order_bagmondo'},
      {id: 58, name: 'ATS.de', img: 'schuhede-ats_de.svg', icon: 'fa-ats_de'}
    ],
    language: 'de',
    stores: [],
    token: '',
    orderToken: '',
    parcelId: 0,
    parcelOptions: [],
    redReturns: [],
    amazonTokenRenewalReminder: [],
    orderWithTokenId: 0,
    orderStatusFilters: [],
    orderPaymentsFilters: [],
    orderChannelsFilters: [],
    alerts: []
  },
  getters: {
    storeById: (state) => (id) => {
      return state.stores.find(store => store.id === id)
    },
    alerts: state => {
      return state.alerts
    },
    orderStatusFilters: state => {
      return state.orderStatusFilters
    },
    orderPaymentsFilters: state => {
      return state.orderPaymentsFilters
    },
    orderChannelsFilters: state => {
      return state.orderChannelsFilters
    },
    redReturns: state => {
      return state.redReturns
    },
    amazonTokenRenewalReminder: state => {
      return state.amazonTokenRenewalReminder
    },
    user: state => {
      return state.user
    },
    language: state => {
      return state.language
    },
    stores: state => {
      return state.stores
    },
    roles: state => {
      return state.roles
    },
    parcelOptions: state => {
      return state.parcelOptions
    },
    parcelId: state => {
      return state.parcelId
    },
    orderWithTokenId: state => {
      return state.orderWithTokenId
    },
    token: state => {
      return state.token
    },
    orderToken: state => {
      return state.orderToken
    },
    loggedInStatus: state => {
      return state.loggedInStatus
    },
    env: state => {
      return state.env
    },
    salesChannels: state => {
      return state.salesChannels
    },
    filterChannels: state => {
      return state.filterChannels
    },
    salesChannelById: state => (id) => {
      return state.salesChannels.find(channel => channel.id === parseInt(id))
    }
  },
  mutations: {
    pushAlert (state, alert) {
      if (alert.dismiss) {
        state.alerts.push(alert)
      } else {
        alert.dismiss = 4
        state.alerts.push(alert)
      }
    },
    removeAlert (state, alert) {
      state.alerts.splice(state.alerts.indexOf(alert))
    },
    updateOrderStatusFilters (state, data) {
      state.orderStatusFilters = data
    },
    updateOrderPaymentsFilters (state, data) {
      if (data.length > 0) {
        state.orderPaymentsFilters = data
      }
      state.orderPaymentsFilters.unshift('all')
    },
    updateOrderChannelsFilters (state, data) {
      if (data.length > 0) {
        state.orderChannelsFilters = data
      }
      state.orderChannelsFilters.unshift('all')
    },
    initialiseStore (state) {
      if (localStorage.getItem('store')) {
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem('store')))
        )
      }
    },
    updateUser (state, user) {
      if (typeof state.user === 'string') {
        state.user = JSON.parse(state.user)
      }
      for (let x in user) {
        state.user[x] = user[x]
      }
      state.user.image = 'user2-160x160.jpg'
    },
    updateRoles (state, roles) {
      Object.keys(state.roles).forEach(sr => {
        state.roles[sr] = false
      })
      Object.keys(roles).forEach(r => {
        state.roles[r] = roles[r]
      })
    },
    updateToken (state, token) {
      state.token = token
    },
    updateOrderToken (state, token) {
      state.orderToken = token
    },
    updateLanguage (state, lang) {
      state.language = lang
    },
    updateStores (state, data) {
      state.stores = data
    },
    updateParcelOptions (state, data) {
      state.parcelOptions = data
    },
    updateParcelId (state, data) {
      state.parcelId = data
    },
    updateErpSystemForCompany (state, data) {
      state.user.erp_system_name = data
    },
    updateOrderWithTokenId (state, data) {
      state.orderWithTokenId = data
    },
    updateLoggedInStatus (state, data) {
      state.loggedInStatus = data
    },
    updateRedReturns (state, data) {
      state.redReturns = data
    },
    updateAmazonTokenRenewalReminder (state, data) {
      state.amazonTokenRenewalReminder = data
    },
    updateSalesChannels (state, data) {
      state.salesChannels = data
    }
  },
  actions: {
    csLogin (context, token) {
      if (store.getters.loggedInStatus) {
        API.get('/logout')
          .then(response => {
            store.commit('updateLoggedInStatus', false)
            window.localStorage.clear()
            API.post('/login/token', {token: token})
              .then(response => {
                store.commit('updateRoles', response.data.roles)
                store.commit('updateToken', JSON.parse(JSON.stringify(response.data.token)))
                store.commit('updateLoggedInStatus', true)
                API.get('/accounting/user')
                  .then(response => {
                    store.commit('updateUser', response.data)
                    API.get('/accounting/stores')
                      .then(response => {
                        store.commit('updateStores', response.data)
                        API.get('/orders/parcel-options')
                          .then(response => {
                            store.commit('updateParcelOptions', response.data)
                            API.get('/accounting/company')
                              .then(company => {
                                store.commit('updateParcelId', company.data.default_parcel_id)
                                store.commit('updateErpSystemForCompany', company.data.erp_system_name)
                              })
                              .catch(error => {
                                this.checkError(error)
                              })
                          })
                      })
                    router.push('home')
                  })
              })
              .catch(error => {
                return error
              })
          })
      } else {
        API.post('/login/token', {token: token})
          .then(response => {
            store.commit('updateRoles', response.data.roles)
            store.commit('updateToken', JSON.parse(JSON.stringify(response.data.token)))
            store.commit('updateLoggedInStatus', true)
            API.get('/accounting/user')
              .then(response => {
                store.commit('updateUser', response.data)
                API.get('/accounting/stores')
                  .then(response => {
                    store.commit('updateStores', response.data)
                    API.get('/orders/parcel-options')
                      .then(response => {
                        store.commit('updateParcelOptions', response.data)
                        API.get('/accounting/company')
                          .then(company => {
                            store.commit('updateParcelId', company.data.default_parcel_id)
                            store.commit('updateErpSystemForCompany', company.data.erp_system_name)
                          })
                      })
                    router.push('home')
                  })
              })
              .catch(error => {
                return error
              })
          })
      }
    },
    login (context, userInput) {
      API.post('/login', userInput)
        .then(response => {
          store.commit('updateRoles', response.data.roles)
          store.commit('updateToken', JSON.parse(JSON.stringify(response.data.token)))
          store.commit('updateLoggedInStatus', true)
          API.get('/accounting/user')
            .then(response => {
              store.commit('updateUser', response.data)
              API.get('/accounting/stores')
                .then(response => {
                  store.commit('updateStores', response.data)
                  API.get('/orders/parcel-options')
                    .then(response => {
                      store.commit('updateParcelOptions', response.data)
                      API.get('/accounting/company')
                        .then(company => {
                          store.commit('updateParcelId', company.data.default_parcel_id)
                        })
                    })
                })
              router.push('home')
            })
        })
        .catch(error => {
          return error
        })
    },
    orderLogin (context) {
      API.get('/login/' + store.getters.orderWithTokenId)
        .then(response => {
          store.commit('updateToken', response.data)
          store.commit('updateLoggedInStatus', true)
          API.get('/accounting/stores')
            .then(response => {
              store.commit('updateStores', response.data)
              API.get('/orders/parcel-options')
                .then(response => {
                  store.commit('updateParcelOptions', response.data)
                  API.get('/accounting/company')
                    .then(company => {
                      store.commit('updateParcelId', company.data.default_parcel_id)
                      router.push('/order-detail')
                    })
                })
            })
        })
    },
    logout (context) {
      if (store.getters.loggedInStatus) {
        API.get('/logout')
          .then(response => {
            store.commit('updateLoggedInStatus', false)
            window.localStorage.clear()
            router.push('/')
          })
      } else {
        window.localStorage.clear()
        router.push('/')
      }
    },
    checkPermissions (context, type) {
      let roles = store.getters.roles
      if (roles === null) {
        window.localStorage.clear()
        router.push('/')
        return false
      }
      return roles.co_admin || roles[type]
    },
    checkError (context, error) {
      if (error.status === 403) {
        return false
      } else if (error.status === 401) {
        store.dispatch('logout')
      } else return true
    },
    getStoreById (context, id) {
      let stores = store.getters.stores
      return stores.find(x => x.id === id)
    }
  }
})
export default store
function getEnv () {
  let productionURLs = ['myplace.qb-schuhe.de', 'qb-schuhe.de', 'qualibet-schuhe.de', 'qbschuhe.de', 'www.qb-schuhe.de', 'www.qualibet-schuhe.de', 'www.qbschuhe.de', 'myplace.schuhe.de']
  if ((productionURLs.indexOf(window.location.hostname)) !== -1) {
    return 'live'
  } else if (window.location.hostname === 'localhost' || window.location.hostname === 'qualibet.local') {
    return 'dev'
  } else if (window.location.hostname === 'myplace.staging-qb.de') {
    return 'staging'
  }
}



// WEBPACK FOOTER //
// ./src/store/index.js